import { addDays, endOfToday, startOfToday, subDays } from 'date-fns';
import { createSelector } from 'reselect';

import { APPOINTMENT_STATUS, APPOINTMENT_TYPE } from 'constants/FilterConstants';
import { getSelectedDealerTimeZoneOffset } from 'selectors/dealerSelectors';
import { getDateFilter } from 'utils/date';

import { getAll as getCollection } from './general';

const getState = state => state.appointments.ui.dashboard;

const getIds = createSelector(getState, state => state.ids ?? []);

export const getAll = createSelector(getIds, getCollection, (ids, collection) => ids.map(id => collection?.[id]) ?? []);

export const getPage = createSelector(getState, ({ page }) => page);

const getFilters = createSelector(getState, state => state.filters);

export { getFilters };

export const getStatusFilter = createSelector(getFilters, filters => filters[APPOINTMENT_STATUS]);

export const getBrandsFilter = createSelector(getFilters, filters => filters.brands ?? []);

export const getTypesFilter = createSelector(getFilters, filters => filters[APPOINTMENT_TYPE] ?? []);

export const getSortFilter = createSelector(getFilters, filters => filters.sort);

export const getTextFilter = createSelector(getFilters, filters => filters.text);

export const getFromFilter = createSelector(
  getFilters,
  getSelectedDealerTimeZoneOffset,
  (filters, timeZone) => (
    filters.from === null ? getDateFilter(subDays(startOfToday(), 7), timeZone) : filters.from
  )
);
export const getToFilter = createSelector(
  getFilters,
  getSelectedDealerTimeZoneOffset,
  (filters, timeZone) => (
    filters.to === null ? getDateFilter(addDays(endOfToday(), 7), timeZone) : filters.to
  )
);

export const getPersistedFilters = createSelector(getFilters, filters => {
  const { from, to, sort, ...persisted } = filters;
  return persisted;
});
